module.exports = __webpack_public_path__ + "img/9_87.bf51e6f8.png";